// Admin session helpers.
// Authentication now uses a server-set httpOnly cookie (immune to XSS token
// theft) instead of any browser storage. The browser attaches the cookie
// automatically on same-origin /api requests.
import axios from 'axios';
import { API } from './site';
import { devWarn } from './log';

// Dedicated client that always sends/receives the session cookie,
// including in cross-origin production setups.
const http = axios.create({ withCredentials: true });

const LEGACY_KEY = 'melopa_admin_token';

// Remove tokens persisted by older app versions.
export function clearLegacyTokens() {
  try {
    window.localStorage.removeItem(LEGACY_KEY);
    window.sessionStorage.removeItem(LEGACY_KEY);
  } catch (e) {
    devWarn('Legacy token cleanup failed:', e);
  }
}

export async function loginAdmin(email, password) {
  const res = await http.post(`${API}/admin/login`, { email, password });
  clearLegacyTokens();
  return res.data;
}

export async function logoutAdmin() {
  try {
    await http.post(`${API}/admin/logout`);
  } catch (e) {
    devWarn('Logout request failed:', e);
  }
  clearLegacyTokens();
}

// Returns { email } when an active admin session cookie exists, else null.
export async function fetchAdminSession() {
  try {
    const res = await http.get(`${API}/admin/me`);
    return res.data;
  } catch (e) {
    return null;
  }
}
